import { SessionInfoRemoteDto } from '../../../generated/signalR/session-info-remote-dto';
import { UserInformationRealTimeData } from '../../../generated/signalR/user-information-real-time-data';
import { LongRunningAction } from '../server-communication/running-actions/types/longRunningAction.decorator';
import { LongRunningContextCategoryTyp } from '../../samwebDescription/samweb/waitingContext/waitingContextCategory';

export class SessionUpdated {
   public static readonly type = '[Session] Session updated';

   constructor(public sessionInfo: SessionInfoRemoteDto) {}
}

export class SessionRelevantDataChanged {
   public static readonly type = '[Session] session relevant data changed';

   constructor() {}
}

export class UserInformationChanged {
   public static readonly type = '[Session] user information changed';

   constructor(public userInformationData: UserInformationRealTimeData) {}
}

export class ToggleSessionControlDialog {
   public static readonly type = '[Session] toggle session control dialog';

   constructor() {}
}

export class CloseSessionControlDialog {
   public static readonly type = '[Session] close session control dialog';

   constructor() {}
}

@LongRunningAction(LongRunningContextCategoryTyp.GLOBAL)
export class TerminateAllUserSessions {
   public static readonly type = '[Session] terminate all user sessions';

   constructor() {}
}

@LongRunningAction(LongRunningContextCategoryTyp.GLOBAL)
export class TerminateCurrentSession {
   public static readonly type = '[Session] terminate current session';

   constructor() {}
}
